export default __webpack_public_path__ + "b97a8c7a57187f694566727836060631.gif";